import React, { Fragment} from 'react';

import { processResponse } from '../../../utilities/processResponse';

import './Section.css';

const ReviewPageSection = (props) => {

    return (
        <Fragment>
            {
                props.type === "pre" ? 
                <div
                    className={`${props.className} section-contain`} 
                    dangerouslySetInnerHTML={{__html: processResponse(props.html)}}>
                </div>
                :
                <div
                    className={`${props.className} section-contain`} 
                    dangerouslySetInnerHTML={{__html: processResponse(props.html)}}>
                </div>
            }
        </Fragment>
    );
}

export default ReviewPageSection;
